import { render, staticRenderFns } from "./MaxtrixTick.vue?vue&type=template&id=b26cee4e&"
import script from "./MaxtrixTick.vue?vue&type=script&lang=js&"
export * from "./MaxtrixTick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports